import { render } from "./EikenChoiceView.vue?vue&type=template&id=4b2f546a&scoped=true&ts=true"
import script from "./EikenChoiceView.vue?vue&type=script&lang=ts"
export * from "./EikenChoiceView.vue?vue&type=script&lang=ts"

import "./EikenChoiceView.vue?vue&type=style&index=0&id=4b2f546a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f546a"]])

export default __exports__